import React from "react";
import useCountdown from "@/hooks/useCountdown";
import { EVENT_DATETIME_ISO } from "@/data/content";

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown({ size = "lg", testId = "countdown" }) {
  const { days, hours, minutes, seconds, done } =
    useCountdown(EVENT_DATETIME_ISO);

  const units = [
    { v: days, label: "HARI", key: "days" },
    { v: hours, label: "JAM", key: "hours" },
    { v: minutes, label: "MINIT", key: "minutes" },
    { v: seconds, label: "SAAT", key: "seconds" },
  ];

  if (done) {
    return (
      <div className="cd-done" data-testid={`${testId}-done`}>
        MALAM ITU TELAH TIBA
      </div>
    );
  }

  return (
    <div
      className={`cd cd--${size}`}
      data-testid={testId}
      aria-label="Kiraan detik menuju konsert"
    >
      {units.map((u, i) => (
        <React.Fragment key={u.key}>
          <div className="cd__unit" data-testid={`${testId}-${u.key}`}>
            <span className="cd__num">{pad(u.v)}</span>
            <span className="cd__label">{u.label}</span>
          </div>
          {i < units.length - 1 && <span className="cd__sep">:</span>}
        </React.Fragment>
      ))}
    </div>
  );
}
